import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "info-tips-full",
  "use": "info-tips-full-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 16 16\" id=\"info-tips-full\"><g clip-path=\"url(#info-tips-full_a)\"><path fill=\"#FF9142\" fill-rule=\"evenodd\" d=\"M8 15.2A7.2 7.2 0 1 0 8 .8a7.2 7.2 0 0 0 0 14.4m.72-3.6a.72.72 0 1 1-1.44 0 .72.72 0 0 1 1.44 0m0-2.16a.72.72 0 0 1-1.44 0V4.4a.72.72 0 0 1 1.44 0z\" clip-rule=\"evenodd\" /></g><defs><clipPath id=\"info-tips-full_a\"><path fill=\"currentColor\" d=\"M0 0h16v16H0z\" /></clipPath></defs></symbol>"
});
var result = sprite.add(symbol);
export default symbol